import BaseComponent from './BaseComponent';

import {
	VictoryBar, VictoryChart, VictoryAxis,
	VictoryStack, VictoryTheme, VictoryTooltip
} from 'victory';

class StackBarChart extends BaseComponent {

	render() {

		const colors = 
			[
				'#547C87', //(Azul verdoso)
				'#8E6B8B', //(Púrpura)
				'#9FB1B5', //(Gris azulado)
				'#C8AD7F', //(Beige)
				'#DAA520', //(Oro viejo)
				'#C0C0C0', //(Plata)
				'#CD853F', //(Bronce)
				'#D2B48C', //(Amarillo claro)
				'#4682B4', //(Azul acero)
				'#FFD700', //(Amarillo oro)
				'#808000', //(Amarillo oliva)
				'#A0522D', //(Marrón)
				'#800080', //(Púrpura)
				'#4B0082', //(Índigo)
				'#6B8E23', //(Verde oliva)
			]

		return (
			<VictoryChart
				domainPadding={20}
				height={this.props.height??200}
				width={this.props.width??600}
				theme={VictoryTheme.material}
				padding={{ top: 10, bottom: 30, left:60 }}
			>
				<VictoryAxis
					tickValues={this.props.data.map((bar,idx) => {
						return idx+1
					})}
					style={{tickLabels: {
						
						fontFamily: "inherit",
						fontSize: 9
					  }}}
					fixLabelOverlap={true}
					tickFormat={this.props.labels?this.props.labels:[]}
				/>
				<VictoryAxis
					dependentAxis
					tickFormat={(x) => (`€${x / 1000}k`)}
				/>
				<VictoryStack>
					{this.props.data?.map((barPiece,count) => {
						return <VictoryBar key={'stackbar_'+count}
							labelComponent={<VictoryTooltip />}
							data={barPiece}
							x="xaxis"
							y="yaxis"
							//colorScale="green"
							style={{
								data: {
								  fill: (p) => {
										return colors[p.datum._stack - 1] ? colors[p.datum._stack - 1] : "#000000"
									}
								}}}
						/>
					})}
				</VictoryStack>
			</VictoryChart>
		)
	}

}

export default StackBarChart;
